import { render, staticRenderFns } from "./tagsview.vue?vue&type=template&id=56c9fff0&scoped=true&"
import script from "./tagsview.vue?vue&type=script&lang=js&"
export * from "./tagsview.vue?vue&type=script&lang=js&"
import style0 from "./tagsview.vue?vue&type=style&index=0&id=56c9fff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c9fff0",
  null
  
)

export default component.exports